import { HOST_REQUIREMENTS } from '../../content/hostRequirements';

// Venue-search VS1.2. The host's "all Yes" lives only in this browser tab
// (sessionStorage) until the venue is saved. VS1.3 reads it and stores it in
// the host's private record. Holds no personal data: a version and a time.
export const STORAGE_KEY = 'yedding.hostRequirements';

export const saveConfirmation = (version, now = new Date()) => {
  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ version, confirmedAt: now.toISOString() }));
    return true;
  } catch (e) {
    // Private mode or storage blocked: VS1.3 asks again at save.
    return false;
  }
};

// Returns {version, confirmedAt} or null. Ignores anything malformed or a
// version that is not in code.
export const readConfirmation = () => {
  try {
    const value = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY));
    if (!value || !HOST_REQUIREMENTS[value.version] || Number.isNaN(Date.parse(value.confirmedAt))) {
      return null;
    }
    return { version: value.version, confirmedAt: value.confirmedAt };
  } catch (e) {
    return null;
  }
};

export const clearConfirmation = () => {
  try {
    window.sessionStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    // nothing to clear
  }
};
